import React from "react";
import PropTypes from "prop-types";
import {Pivot as RibbonPivot} from "@advthreat/ribbon-components";
import {FEATURE} from "api/telemetry/";

/**
 * Pivot Menu impl for Entity List
 */
const PivotMenu = ({pivotValues}) => {
  if (!pivotValues?.type || !pivotValues?.value) return null;

  return (
    <div className="d-flex mr-2" data-testid={"EntityListItem-PivotMenu"}>
      <RibbonPivot
        type={pivotValues?.type}
        value={pivotValues?.value}
        hideButtonDisposition
        telemetryLocationKey={FEATURE.INCIDENT_DETAIL.ENTITY_CARD}
      />
    </div>
  );
};

PivotMenu.propTypes = {
  pivotValues: PropTypes.shape({
    type: PropTypes.string,
    value: PropTypes.string
  })
};

export default PivotMenu;
